export default __webpack_public_path__ + "media/images/mailer-new/common/logo-header-b62c3312a4564aa4f1c4e952c9fc8547.png";